import type { SVGProps } from "react";
import * as React from "react";
const SvgGcal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="m17.263 6.737-4.737-.526-5.79.526L6.212 12l.526 5.263 5.263.658 5.263-.658.526-5.395-.526-5.131Z"
    />
    <path
      fill="#1A73E8"
      d="M8.896 14.903c-.393-.266-.666-.654-.814-1.168l.913-.376c.083.316.227.56.434.734.205.174.455.26.747.26.3 0 .556-.091.77-.273a.87.87 0 0 0 .322-.693.86.86 0 0 0-.339-.703c-.226-.181-.51-.272-.85-.272h-.528v-.904h.474c.292 0 .538-.079.738-.237.2-.158.3-.374.3-.649 0-.244-.09-.44-.268-.585-.18-.146-.405-.22-.68-.22-.269 0-.482.071-.64.215-.158.143-.272.32-.345.527l-.904-.376c.12-.34.34-.64.662-.899.323-.259.734-.39 1.234-.39.37 0 .703.072.998.215.295.144.526.342.693.595.167.254.25.538.25.854 0 .322-.077.595-.233.818a1.606 1.606 0 0 1-.572.515v.054c.299.125.542.316.734.572a1.5 1.5 0 0 1 .287.921c0 .358-.09.678-.272.958-.182.28-.433.501-.752.662-.32.16-.679.242-1.077.242a2.23 2.23 0 0 1-1.282-.397ZM14.5 10.371l-.997.725-.502-.76L14.8 9.037h.69v6.12h-.99V10.37Z"
    />
    <path
      fill="#EA4335"
      d="M17.263 22 22 17.263l-2.368-1.052-2.369 1.052-1.052 2.369L17.263 22Z"
    />
    <path
      fill="#34A853"
      d="M5.684 19.632 6.737 22h10.526v-4.737H6.737l-1.053 2.369Z"
    />
    <path
      fill="#4285F4"
      d="M3.579 2C2.707 2 2 2.707 2 3.579v13.684l2.368 1.053 2.369-1.053V6.737h10.526l1.053-2.369L17.263 2H3.58Z"
    />
    <path
      fill="#188038"
      d="M2 17.263v3.158C2 21.294 2.707 22 3.579 22h3.158v-4.737H2Z"
    />
    <path
      fill="#FBBC04"
      d="M17.263 6.737v10.526H22V6.737l-2.368-1.053-2.369 1.053Z"
    />
    <path
      fill="#1967D2"
      d="M22 6.737V3.579C22 2.706 21.293 2 20.421 2h-3.158v4.737H22Z"
    />
  </svg>
);
export default SvgGcal;
